import React from "react";

export function deriveEvaluationOutcome({ score, passMark, attemptNumber, maxAttempts, passed }) {
  const normalizedScore = Number(score);
  const normalizedPassMark = Number(passMark);
  const normalizedAttemptNumber = Number(attemptNumber);
  const normalizedMaxAttempts = Number(maxAttempts);

  if (![normalizedScore, normalizedPassMark].every(Number.isFinite)) return null;

  const passedResult = typeof passed === "boolean"
    ? passed
    : normalizedScore >= normalizedPassMark;
  const attemptsRemaining = Math.max(0, normalizedMaxAttempts - normalizedAttemptNumber);
  const pointsNeeded = Math.max(0, normalizedPassMark - normalizedScore);

  if (!passedResult && attemptsRemaining > 0) {
    return {
      state: "not-passed",
      heading: "Not passed yet",
      message: `You need ${pointsNeeded} more points to reach the pass mark. You have ${attemptsRemaining} ${attemptsRemaining === 1 ? "attempt" : "attempts"} remaining.`,
    };
  }
  if (!passedResult) {
    return {
      state: "not-passed",
      heading: "Not passed",
      message: `Your final score was ${normalizedScore}. The pass mark was ${normalizedPassMark}.`,
    };
  }
  if (normalizedScore >= 80) {
    return {
      state: "excellent",
      heading: "Excellent work",
      message: "You passed with a strong result and showed confident creative development.",
    };
  }
  return { state: "passed", heading: "Passed", message: "You reached the pass mark." };
}

export default function EvaluationOutcome(props) {
  const outcome = deriveEvaluationOutcome(props);
  if (!outcome) return null;

  return (
    <section className={`evaluation-outcome evaluation-outcome--${outcome.state}`} aria-live="polite">
      <h3>{outcome.heading}</h3>
      <p>{outcome.message}</p>
    </section>
  );
}
